
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartMagneticVariationIec as ObiChartMagneticVariationIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-magnetic-variation-iec.js';
 
 
 

 
 export const ObiChartMagneticVariationIec = createComponent({
   react: React,
   tagName: 'obi-chart-magnetic-variation-iec',
   elementClass: ObiChartMagneticVariationIecElement,
   events: {
     
   }
  });
 
 